/* eslint-env node */

<!-- A group of radio buttons styled as a colour picker.
  Could be SSG. Bahviourt is html driven.
  Only uses JS to update the "Selected colour: xxx" heading -->

<!-- Install Vue CLI: Just use npx before commands below, or npm install -g @vue/cli @vue/cli-service-global -->
<!-- More info: https://cli.vuejs.org/guide/prototyping.html -->
<!-- Use these terminal commands from the project root folder: -->
<!-- • Dev locally: npx vue serve ./vue/src/components/Swatch.vue -->
<!-- • Build: npx vue build ./vue/src/components/Swatch.vue --dest assets --target wc --name yoto-swatch -->
<!-- • Build: (deprecated?) npx vue-cli-service build ./vue/src/components/Swatch.vue --dest assets --target wc --name yoto-swatch --watch -->

<!-- TODO: Better solution for HARD CODED colour hex lookup. Can we get item.hex from CMS? -->

<!-- Important: By placing the <input> field first in its parent,
     subsequent elements can be styled by its :checked state -->
<template>
  <fieldset class="swatch" :data-selected-index="selectedIndex">
    <legend class="swatch__heading" aria-live="polite">{{ fieldsetLabel }}</legend>
    <!-- IMPORTANT: The order of the hex codes here must match Shopify! -->
    <label
      v-for="(item,i) in items"
      :key="item.id"
      class="swatch__item"
      :style="{ color: item.hex || hexCodesArray[i] }"
    >
      <input
        type="radio"
        class="swatch__field"
        :value="item.id"
        :name="swatchId"
        :checked="item.selected && !item.disabled"
        :data-unavailable="!item.available"
        :disabled="item.disabled || (!item.available && disableUnavailable)"
        v-on:input="onInput"
        ref="fields"
      />
      <span class="swatch__sample" :data-label="itemLabel(item)"></span>
      <span class="swatch__name">{{ itemLabel(item) }}</span>
    </label>
  </fieldset>
</template>

<script>
export default {
  name: 'Swatch',

  props: {
    // Default to a short random string to ensure a unique radio-group name:
    swatchId: { type: String, default: function() { return Math.random().toString(36).substr(-4) } },
    label: { type: String, default: 'Choose color:' },
    labelSelected: { type: String, default: 'You chose:' },
    labelUnavailable: { type: String, default: '(Not available)' },
    disableUnavailable: { type: Boolean, default: false },
    itemsJson: String,
    items: {
      type: Array,
      default: function() {
        return this.itemsJson ? JSON.parse(this.itemsJson) : DEFAULT_DEMO_SWATCH
      }
    },
    // Only needed when items do not include item.hex. Looked up by index, so the order is important.
    hexCodes: {
      type: [String, Array],
      default: function() {
        return ['#fad94a','#55c0f0','#a2c63e','#f4ae3d','#e63323','#dda7cd','#767474']
      }
    }
  },

  data: function data() {
    return {
      selectedIndex: this.items.findIndex(
        item => item.selected && !item.disabled
      )
    };
  },

  computed: {
    // Get label for the component, eg: "Select a colour" or "You have chosen Blue":
    fieldsetLabel: function fieldsetLabel() {
      return this.selectedIndex === -1
        ? this.label
        : `${this.labelSelected} ${this.items[this.selectedIndex]?.name || this.items[this.selectedIndex]?.title}`;
    },

    hexCodesArray: function hexCodesArray() {
      console.log(this.hexCodes);
      return typeof this.hexCodes === 'string' ? JSON.parse(this.hexCodes) : this.hexCodes;
    }
  },

  methods: {
    // Update selectedIndex when a colour is chosen:
    onInput: function onInput(e) {
      // Derive index of the selected checkbox:
      this.selectedIndex = this.items.findIndex(
        item => (String(item.id) === String(e.target.value) && e.target.checked)
      );

      // Set custom attribute on the container element to expose the selected index:
      this.$el.getRootNode().host.setAttribute('data-selected-index', this.selectedIndex);
    },

    // Get the label or disabled message (if disabled===true then derive a disabled message)
    itemLabel: function itemLabel(item) {
      const unavailable = item.disabled || !item.available;
      return (
        (!unavailable && (item.name || item.title)) ||
        (typeof unavailable === 'string' && unavailable) ||
        `${item.name || item.title} ${this.labelUnavailable}`
      );
    }
  }
};

// const HEX = {
//   red: '#e63323',
//   org: '#f4ae3d',
//   grn: '#a2c63e',
//   yel: '#fad94a',
//   blu: '#55c0f0',
//   pnk: '#dda7cd'
// }

// Only used as defaults so the component does not render empty:
// WARNING: In Shopify site, the hext codes come from the array above, not here!
const DEFAULT_DEMO_SWATCH = [
  { id: 'yel', name: 'Bumblebee Yellow' },
  { id: 'blu', name: 'Marge Simpson blue', selected: true },
  { id: 'grn', name: 'Green',  disabled: 'Sorry, Green is not available' },
  { id: 'org', hex: '#f4ae3d', name: 'Orangy orange' },
  { id: 'red', hex: '#e63323', name: 'Reddy red' },
  { id: 'pnk', hex: '#dda7cd', name: 'Savage Pink', disabled: true },
  { id: 'gry', hex: '#767474', name: 'Grey', disabled: true }
]
</script>

<style scoped>
.swatch {
  border: none;
  display: flex;
  flex-direction: row;
  text-align: left;
  /* Ignore any taps outside the swatches, to avoid accidental navigation etc */
  pointer-events: none;
}

.swatch__item {
  display: inline-block;
  pointer-events: auto;
  position: relative;
}

/* Gap between items: */
.swatch__item ~ .swatch__item {
  margin-left: 14px;
}
/* Narrower gap when more than 6 items: */
.swatch__item:nth-last-child(7) ~ .swatch__item {
  margin-left: 5px;
}

/* CSS Tooltip */
/* Original code for the SVG triangle before we minify & base64 encode:
    <svg height="10" width="10">
      <polygon points="0,0 5,10 10,0" fill="#000" />
    </svg>
  */
/* Show tooltip on hover or when focused-but-not-hovering-anywhere on the swatch:
   This technique prevents 2 tooltips appearing when one is focused and another is hovered */
.swatch__sample:hover:before,
.swatch:not(:hover) .swatch__field:focus-visible + .swatch__sample:before {
  content: attr(data-label);
  color: #fff;
  display: block;
  border-radius: 0.3em 0.3em 1.2em 1.2em;
  padding: 0.5em 0.5em calc(10px + 0.5em) 0.5em; /* Allow 10px for the beak */
  font-size: 0.8rem;
  line-height: 1;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -100%);
  white-space: nowrap;
  /* Tooltip "beak" triangle and background: */
  background: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='10' width='10'%3E%3Cpath fill='%23000' d='M0 0l5 10 5-10z'/%3E%3C/svg%3E")
      no-repeat 50% 100%,
    linear-gradient(to top, transparent, 9px, transparent, 9px, #000);
}

.swatch__sample {
  background-color: currentColor;
  border-radius: 2px;
  display: inline-block;
  width: 32px;
  height: 32px;
  position: relative;
  cursor: pointer;
  /* To soften the transition when swatch is selected: */
  box-shadow: 0 0 0 0 #000;
  transition: box-shadow 0.2s;
}

:checked + .swatch__sample {
  box-shadow: 0 0 0 3px #000;
  z-index: 1;
}

/* Styles for both the checkmark and the strike-through */
.swatch__sample:after {
  content: '';
  display: block;
  color: #000;
  position: absolute;
  border-bottom: 2px solid #000;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

[disabled] + .swatch__sample {
  cursor: not-allowed;
  box-shadow: none;
}

/* Strike-through (disabled/unavailable) drawn with CSS: */
[disabled] + .swatch__sample:after,
[data-unavailable] + .swatch__sample:after {
  margin: 15px 0 0 -1px;
  width: 32px;
  height: 0;
}

/* Checkmark (selected/tick) drawn with CSS: */
/* Note how this selector is positioned after the [data-unavailable] one to override */
:checked + .swatch__sample:after {
  margin: 8px 0 0 7px;
  width: 16px;
  height: 8px;
  border-left: 2px solid #000;
}

/* Equivalent of .sr-only for screenreaders, so that each radio has an a11y label */
.swatch__name,
.swatch__field {
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
  -webkit-clip-path: inset(50%);
  clip-path: inset(50%);
  height: 1px;
  width: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
}
</style>
